<template>
    <v-layout row wrap v-redirect-if-no-permission:INTERVIEW_MANAGEMENT>
        <loading-component :value="loading"/>
        <v-flex xs12>
            <v-chip v-for="status of statuses" :key="'status-' + status.id" :color="status.color"
                    :disabled="activeStatuses.indexOf(status.id) === -1"
                    @click="statusClicked(status)"
                    @contextmenu.prevent="activeStatus = status"
                    :close="status.id !== 1"
                    @input="deleteChip(status.id)">
                {{status.name}}
            </v-chip>
            <v-divider/>
            <v-btn flat color="primary" @click="status = {color: null,name: null},newStatusDialog = true">
                {{ $t("acquisitionPage.newStatus") }}
            </v-btn>
            <v-btn flat color="primary" @click="searchDialog = true">
                {{ $t("acquisitionPage.search") }}
            </v-btn>
        </v-flex>
        <v-dialog v-model="searchDialog" max-width="50%">
            <v-card>
                <v-card-title primary-title class="title font-weight-bold">
                    {{ $t("acquisitionPage.searchInterviewsTitle") }}
                </v-card-title>
                <v-card-text>
                    <choose-captains-multi :multi="false" v-model="captain_id" :label='$t("acquisitionPage.captain")'/>
                    <v-list two-line v-if="captain_id != null && captain_interviews.length > 0">
                        <v-list-tile
                                v-for="item of captain_interviews"
                                :key="'interview-tile-'+item.id"
                                @click="interviewClick({interview: item})">
                            <v-list-tile-content>
                                <v-list-tile-title v-html="item.datetime"></v-list-tile-title>
                                <v-list-tile-sub-title
                                        v-html="statuses.filter(i => i.id === item.interview_status_id)[0].name"></v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="newCaptainDialog" max-width="50%">
            <new-captain @created="captainCreated"/>
        </v-dialog>
        <v-dialog v-model="newStatusDialog" max-width="50%">
            <v-card>
                <v-card-title primary-title class="title font-weight-bold">
                    <template v-if="activeStatus && activeStatus.id">
                        {{ $t("acquisitionPage.updateStatusTitle") }}
                    </template>
                    <template v-else>
                        {{ $t("acquisitionPage.createStatusTitle") }}
                    </template>
                </v-card-title>
                <v-divider/>
                <v-card-text>
                    <v-form ref="form">
                        <v-text-field v-model="status.name" :label='$t("acquisitionPage.statusName")'
                                      :rules="[v => !!v && v.length > 2 || $t('acquisitionPage.ruleMinThreeChars')]"/>
                        {{ $t("acquisitionPage.colorLabel") }}
                        <v-text-field v-model="status.color" readonly disabled :rules="[v=> !!v || $t('acquisitionPage.ruleRequired')]"/>
                        <swatches v-model="status.color" colors="material-light" inline/>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-layout justify-center>
                        <v-btn color="success" @click="saveStatus">
                            {{ $t("acquisitionPage.save") }}
                        </v-btn>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog :value="!!interviewDialog" @input="interviewDialog = null" max-width="50%" lazy>
            <v-card>
                <v-card-title primary-title class="title font-weight-bold">
                    {{ $t("acquisitionPage.editInterviewTitle") }}
                </v-card-title>
                <v-divider/>
                <v-card-title>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <v-menu
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px">
                                <template slot="activator">
                                    <v-text-field
                                            v-model="interview.date"
                                            :label='$t("acquisitionPage.date")'
                                            prepend-icon="event"
                                            readonly
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="interview.date"></v-date-picker>
                            </v-menu>
                            <v-menu
                                    :close-on-content-click="false"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px">
                                <template slot="activator">
                                    <v-text-field
                                            v-model="interview.time"
                                            :label='$t("acquisitionPage.time")'
                                            prepend-icon="event"
                                            readonly
                                    ></v-text-field>
                                </template>
                                <v-time-picker v-model="interview.time"></v-time-picker>
                            </v-menu>
                        </v-flex>
                        <v-flex xs12 v-if="interview.captain">
                            {{ $t("acquisitionPage.captain") }}: {{interview.captain.first_name}} {{interview.captain.last_name}} (
                            {{interview.captain.username}} )
                            <router-link :to="{
                                name: 'CaptainProfile',
                                params : {id: interview.captain.id}
                            }" target="_blank">
                                {{ $t("acquisitionPage.goToProfile") }}
                            </router-link>
                        </v-flex>
                        <v-flex xs12 v-else>
                            {{ $t("acquisitionPage.noCaptain") }}
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                    :items="statuses"
                                    item-text="name"
                                    item-value="id"
                                    v-model="interview.interview_status_id"
                                    :label='$t("acquisitionPage.status")'
                                    solo
                            ></v-select>
                        </v-flex>
                    </v-layout>
                    <v-layout justify-center>
                        <v-btn flat color="primary" @click="saveInterview">
                            {{ $t("acquisitionPage.save") }}
                        </v-btn>
                    </v-layout>
                </v-card-title>
            </v-card>
        </v-dialog>
        <v-dialog v-model="createInterviewDialog" max-width="50%" lazy>
            <interview-creator :key="createInterviewDialog"
                               @saved="interviewCreated" :statuses="statuses"
                               @create_captain="newCaptainDialog = true"/>
        </v-dialog>
        <v-flex sm12>
            <full-calendar
                    ref="calendar"
                    default-view="timeGridDay"
                    :events="events"
                    :editable="true"
                    :event-duration-editable="false"
                    :all-day-slot="false"
                    slot-duration="00:15:00"
                    @eventClick="interviewClick"
                    :select-overlap="true"
                    @dateClick="dateClick"
                    event-order="start"
                    @eventDrop="eventDrop"
                    :plugins="calendarPlugins"
                    @datesRender="datesRender"
            />
        </v-flex>
    </v-layout>
</template>

<script>
    import FullCalendar from "@fullcalendar/vue";
    import LoadingComponent from "@/components/LoadingComponent";
    import FullCalendarTimeGrid from "@fullcalendar/timegrid";
    import FullCalendarInteraction from "@fullcalendar/interaction";
    import Swatches from "vue-swatches";
    import ChooseCaptainsMulti from "@/components/monaco/input/ChooseCaptainMulti";
    import NewCaptain from "@/components/NewCaptain";
    import InterviewCreator from "@/components/driver_acquisition/InterviewCreator";

    export default {
        name: "Interviews",
        title() {
            return this.$t("acquisitionPage.pageTitleInterviews");
        },
        components: {InterviewCreator, ChooseCaptainsMulti, LoadingComponent, FullCalendar, Swatches, NewCaptain},
        data() {
            return {
                date: null,
                loading: false,
                interviews: [],
                sliceInfoDialog: false,
                slice: null,
                newCaptainDialog: false,
                statuses: [],
                activeStatuses: [],
                searchDialog: false,
                newStatusDialog: false,
                captain_id: null,
                status: {
                    name: null,
                    color: null
                },
                captain_interviews: [],
                createInterviewDialog: false,
                interview: {
                    captain: {
                        first_name: null,
                        last_name: null,
                        id: null
                    },
                    date: null,
                    time: null,
                    interview_status_id: null
                },
                activeStatus: null,
                interviewDialog: null,
                newInterview: {
                    date: null,
                    time: null,
                    captain: null,
                    interview_status_id: 1
                },
            }
        },
        watch: {
            searchDialog() {
                this.captain_id = null;
            },
            activeStatus(val) {
                if (val !== null) {
                    this.status = {
                        ...val
                    };
                    this.newStatusDialog = true;
                }
            },
            async date(val) {
                this.loading = true;
                const params = new URLSearchParams();
                params.append('date', val);
                const {data: {data: interviews}} = await this.axios.get(this.api.ACTIONS.INTERVIEWS, {
                    params
                });
                this.interviews = interviews;
                this.loading = false;
            },
            newStatusDialog(val) {
                if (!val) {
                    this.activeStatus = null;
                    this.reset()
                }
            },
            sliceInfoDialog(val) {
                if (!val)
                    this.reset();
            },
            newCaptainDialog(val) {
                if (!val)
                    this.reset();
            },
            createInterviewDialog(val) {
                if (!val)
                    this.reset();
            },
            interviewDialog(val) {
                if (!val)
                    this.reset();
            },
            async captain_id(val) {
                if (!val) {
                    this.captain_interviews = [];
                    return;
                }
                this.loading = true;


                const params = new URLSearchParams();
                params.append('captain_id', val);

                const {data: {data}} = await this.axios.get(this.api.ACTIONS.INTERVIEWS, {params});
                console.log(data);
                this.captain_interviews = data;

                this.loading = false;
            }
        },
        methods: {
            interviewCreated(interview, captain) {
                const slice = this.interviews.length > 0 ? moment(this.interviews[0].end_datetime).diff(moment(this.interviews[0].datetime), 'minute') : 30;
                this.interviews = [...this.interviews, {
                    ...interview,
                    captain,
                    end_datetime: moment(interview.datetime).add(slice, 'minute').format("YYYY-MM-DD HH:mm")
                }];
                this.createInterviewDialog = false;
            },
            reset() {
                this.status = {
                    name: null,
                    color: null
                };
                this.interview = {
                    captain: {
                        first_name: null,
                        last_name: null,
                        id: null
                    },
                    date: null,
                    time: null,
                    interview_status_id: null
                };
                this.newInterview = {
                    date: null,
                    time: null,
                    captain: null,
                    interview_status_id: 1
                };
            },
            captainCreated(captain) {
                this.newCaptainDialog = false;
                window.getApp.$emit("SHOW_TOAST", this.$t("acquisitionPage.toastCaptainCreated"), "green");
                this.newInterview.captain = {
                    text: captain.first_name + " " + captain.last_name + " " + captain.username + " " + captain.whatsapp_number + " " + captain.email,
                    ...captain
                };
            },
            dateClick({dateStr}) {
                this.newInterview.time = moment(dateStr).format("HH:mm");
                this.newInterview.date = moment(dateStr).format("YYYY-MM-DD");
                this.newInterview.captain = null;
                this.newInterview.interview_status_id = null;
                this.createInterviewDialog = true;
            },
            eventDrop({event, revert}) {
                this.loading = true;
                const date = moment(event.start).format("YYYY-MM-DD");
                const time = moment(event.start).format("HH:mm");
                this.axios.put(this.api.ACTIONS.INTERVIEWS + '/' + event.id, {
                    datetime: date + ' ' + time
                }).then(
                    () =>
                        this.interviews = this.interviews.map(
                            item => item.id == event.id ? Object.assign(item, {
                                datetime: moment(event.start).format("YYYY-MM-DD HH:mm"),
                                end_datetime: moment(event.end).format("YYYY-MM-DD HH:mm")
                            }) : item
                        )
                ).catch(
                    revert
                ).finally(
                    () => this.loading = false
                )
            },
            deleteChip(interview_status_id) {
                this.loading = true;
                this.axios.delete(this.api.ACTIONS.INTERVIEW_STATUS + '/' + interview_status_id)
                    .then(
                        () => {
                            window.getApp.$emit("SHOW_TOAST", this.$t("acquisitionPage.toastDeleted"), "green");
                            this.activeStatuses = this.activeStatuses.filter(
                                id => id != interview_status_id
                            );
                            this.statuses = this.statuses.filter(
                                ({id}) => id != interview_status_id
                            );
                        }
                    )
                    .catch(
                        () => window.getApp.$emit("SHOW_TOAST", this.$t("acquisitionPage.toastDeleteStatusFailed"), "red")
                    )
                    .finally(() => this.loading = false)
            },
            datesRender({view}) {
                this.date = moment(view.activeStart).format("YYYY-MM-DD")
            },
            saveInterview() {
                const interview = this.interview;
                this.loading = true;
                if (!!interview.id) {
                    this.axios.put(this.api.ACTIONS.INTERVIEWS + '/' + interview.id, {
                        datetime: interview.date + ' ' + interview.time,
                        interview_status_id: interview.interview_status_id
                    }).then(
                        ({data: {data: newInterview}}) => {
                            this.interviews = this.interviews.map(
                                item => interview.id == item.id ? newInterview : item
                            );
                            this.interviewDialog = false;
                        }
                    ).finally(
                        () => this.loading = false
                    )
                }
            },
            interviewClick({event, interview}) {
                this.interviewDialog = true;
                if (interview)
                    this.interview = interview;
                else
                    this.interview = this.interviews.filter(
                        ({id}) => id == event.id
                    )[0];
                this.interview = {
                    ...this.interview,
                    date: moment(this.interview.datetime).format("YYYY-MM-DD"),
                    time: moment(this.interview.datetime).format("HH:mm")
                }
            },
            saveStatus() {
                if (this.$refs.form.validate()) {
                    this.loading = true;
                    const id = this.activeStatus ? this.activeStatus.id : null;
                    if (id) {
                        this.axios.put(
                            this.api.ACTIONS.INTERVIEW_STATUS + '/' + id,
                            this.status
                        ).then(
                            () => {
                                this.statuses = this.statuses.map(
                                    status => status.id === id ? this.status : status
                                );
                                this.newStatusDialog = false;
                            }
                        ).finally(
                            () =>
                                this.loading = false
                        );
                    } else {
                        this.axios.post(
                            this.api.ACTIONS.INTERVIEW_STATUS,
                            this.status
                        ).then(
                            ({data: {data: status}}) => {
                                this.statuses = [...this.statuses, status];
                                this.newStatusDialog = false;
                            }
                        )
                            .finally(() => this.loading = false)
                    }
                }
            },
            statusClicked(status) {
                if (this.activeStatuses.indexOf(status.id) === -1) {
                    this.activeStatuses = [...this.activeStatuses, status.id];
                } else {
                    this.activeStatuses = this.activeStatuses.filter(id => id !== status.id);
                }
            }
        },
        computed: {
            calendarPlugins() {
                return [FullCalendarTimeGrid, FullCalendarInteraction];
            },
            events() {
                return this.interviews
                    .filter(interview => this.activeStatuses.indexOf(interview.interview_status_id) !== -1)
                    .map(({id, datetime, end_datetime, captain, interview_status_id}) => ({
                            start: datetime,
                            end: end_datetime,
                            id,
                            captain,
                            title: captain ? (captain.first_name + ' ' + captain.last_name + ' ( ' + captain.username + ' ) ') : this.$t("acquisitionPage.noCaptain"),
                            color: this.statuses.filter(({id}) => id == interview_status_id)[0].color
                        })
                    )
            }
        },
        mounted() {
            this.loading = true;
            this.axios.get(this.api.ACTIONS.INTERVIEW_STATUS)
                .then(
                    async ({data: {data}}) => {
                        this.statuses = data;
                        this.activeStatuses = data.map(({id}) => id);
                        this.loading = false;
                    }
                )
        }
    }
</script>

<style scoped>
    @import '~vue-swatches/dist/vue-swatches.min.css';
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/timegrid/main.css';
</style>